<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <el-form :inline="true" ref="form" :model="form" label-width="80px">
      <el-form-item label="用户电话">
        <el-input v-model="form.phone" placeholder="请输入用户电话"></el-input>
      </el-form-item>
      <el-form-item label="转移水卡">
        <el-input v-model="form.cardNo" placeholder="请输入转移卡号"></el-input>
      </el-form-item>
      <el-form-item label="操作人">
        <el-input
          v-model="form.adminName"
          placeholder="请输入操作人"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属分区">
        <el-select
          v-model="form.regionId"
          multiple
          filterable
          placeholder="全部"
        >
          <el-option
            v-for="(v, i) in zoneArr"
            :key="i"
            :label="v.regionName"
            :value="v.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="转移时间">
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        至
        <el-date-picker
          v-model="form.endTime"
          :picker-options="pickerOptionsEnd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getList()">查询</el-button>
        <el-button
          @click="
            form = { regionId: [], startTime: '', endTime: '' };
            getList();
          "
          >重置</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <el-table border :data="tableData" stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="companyName" label="归属企业"> </el-table-column>
      <el-table-column prop="regionName" label="所属分区"> </el-table-column>
      <el-table-column prop="phone" label="用户电话"> </el-table-column>
      <el-table-column prop="cardNo" label="转移水卡">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardNo +
                '（' +
                (scope.row.cardServer == 1
                  ? '社区售水机'
                  : scope.row.cardServer == 2
                  ? '楼宇单元售水机'
                  : scope.row.cardServer == 3
                  ? '家用净水器'
                  : '- -') +
                '）'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="cardMoney" label="转移金额(赠送/实收)">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardMoney +
                '(' +
                (scope.row.cardMoneySend ? scope.row.cardMoneySend : 0) +
                '/' +
                (scope.row.cardMoneyPay ? scope.row.cardMoneyPay : 0) +
                ')'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="toCardNo" label="接收水卡">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.toCardNo +
                '（' +
                (scope.row.toCardServer == 1
                  ? '社区售水机'
                  : scope.row.toCardServer == 2
                  ? '楼宇单元售水机'
                  : scope.row.toCardServer == 3
                  ? '家用净水器'
                  : '- -') +
                '）'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="adminName" label="操作人"> </el-table-column>
      <el-table-column prop="createTime" label="转移时间"> </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {
        regionId: [],
      },
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      qiyeArr: [],
      zoneArr: [],
    };
  },
  created() {
    this.getList();
    // this.getQiye();
    this.getZone();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  methods: {
    // 企业下拉
    getQiye() {
      this.$api.enterprise.enterpriseListPullNew().then((res) => {
        if (res.code === 200) {
          this.qiyeArr = res.data;
        }
      });
    },
    // 分区下拉
    getZone() {
      this.$api.marketing.allZonePull().then((res) => {
        console.log(res, "555");
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.waterCard
        .shiftRecord({
          pageNum: this.page,
          pageSize: this.pageSize,
          phone: this.form.phone,
          cardNo: this.form.cardNo,
          regionId: this.form.regionId,
          adminName: this.form.adminName,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            // res.data.rows.forEach((v) => {
            //   v.phone = v.phone.substr(0, 3) + "****" + v.phone.substr(7);
            // });
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
  },
};
</script>

<style lang="scss" scoped></style>
